module.exports = __webpack_public_path__ + "img/1.08.e87e6cfb.jpg";